"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _core = require("@material-ui/core");
const useStyles = exports.useStyles = (0, _core.makeStyles)(theme => ({
  container: {
    position: 'fixed',
    right: 0,
    top: '10px',
    maxWidth: '300px',
    width: '100%',
    padding: '8px 12px',
    display: 'flex',
    gap: '12px',
    alignItems: 'center',
    backgroundColor: '#FFF',
    borderRadius: '4px',
    boxShadow: '-10px 10px 20px -10px rgba(0,0,0,0.5)',
    transform: 'translateX(75%)',
    opacity: 0.5,
    transitionProperty: 'transform, opacity',
    transitionDuration: theme.transitions.duration.standard
  },
  activeContainer: {
    flexDirection: 'row-reverse',
    transform: 'translateX(0)',
    opacity: 1,
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
      borderRadius: 0,
      top: 0
    }
  },
  settings: {
    flexGrow: 1
  }
}));